{
  "schemaVersion": 1,
  "catalogId": "testcs-building-core-v1",
  "displayName": "TESTCS Core Building Kit",
  "description": "Оригинальный модульный набор TESTCS: понятное строительство комнатами и каталогом, соединённое с серверно-проверяемой snap-системой.",
  "units": "meters",
  "coordinateSystem": {
    "handedness": "right",
    "upAxis": "Y",
    "forwardAxis": "-Z",
    "positionOrder": ["x", "y", "z"]
  },
  "grid": {
    "horizontalStepM": 0.5,
    "verticalStepM": 0.25,
    "rotationStepDeg": 90,
    "snapToleranceM": 0.08,
    "rotationToleranceDeg": 2
  },
  "economy": {
    "currency": "build-credit",
    "materialUnits": ["wood", "stone", "metal", "glass", "fabric", "electronics"]
  },
  "sourcePolicy": {
    "defaultAuthor": "TESTCS",
    "defaultLicense": "TESTCS-original",
    "assetRefsMustBeProjectOwnedOrRedistributable": true
  },
  "snapTypes": {
    "foundation.edge": ["foundation.edge"],
    "foundation.top": ["floor.bottom", "stairs.base"],
    "floor.bottom": ["foundation.top", "floor.top"],
    "floor.top": ["floor.bottom", "stairs.base", "furniture.base", "light.floor"],
    "floor.wall": ["wall.base", "window.base", "door.base"],
    "wall.side": ["wall.side", "window.side", "door.side"],
    "wall.top": ["floor.bottom", "roof.bottom"],
    "wall.surface": ["light.wall"],
    "stairs.base": ["foundation.top", "floor.top"],
    "stairs.landing": ["floor.edge"],
    "roof.bottom": ["wall.top", "floor.top"],
    "furniture.base": ["floor.top"],
    "light.wall": ["wall.surface"],
    "light.floor": ["floor.top"]
  },
  "modules": [
    {
      "id": "foundation-stone-4x4",
      "version": 1,
      "category": "foundation",
      "displayName": "Каменный фундамент 4×4",
      "dimensionsM": [4, 0.4, 4],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/foundation/stone-4x4",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "edge-n", "type": "foundation.edge", "positionM": [0, 0.2, -2], "normal": [0, 0, -1]},
        {"id": "edge-s", "type": "foundation.edge", "positionM": [0, 0.2, 2], "normal": [0, 0, 1]},
        {"id": "edge-e", "type": "foundation.edge", "positionM": [2, 0.2, 0], "normal": [1, 0, 0]},
        {"id": "edge-w", "type": "foundation.edge", "positionM": [-2, 0.2, 0], "normal": [-1, 0, 0]},
        {"id": "top", "type": "foundation.top", "positionM": [0, 0.4, 0], "normal": [0, 1, 0]}
      ],
      "placement": {"requiresPlot": true, "terrainMode": "flatten", "maxSlopeDeg": 12},
      "collider": {"type": "box", "sizeM": [4, 0.4, 4]},
      "cost": {"credits": 90, "materials": {"stone": 40, "metal": 2}},
      "structural": {"massKg": 1600, "loadKg": 1600, "capacityKg": 18000, "supportMode": "ground-anchor"},
      "tags": ["canal", "masonry", "weatherproof"]
    },
    {
      "id": "foundation-pile-4x4",
      "version": 1,
      "category": "foundation",
      "displayName": "Свайный фундамент 4×4",
      "dimensionsM": [4, 1.8, 4],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/foundation/pile-4x4",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "edge-n", "type": "foundation.edge", "positionM": [0, 1.6, -2], "normal": [0, 0, -1]},
        {"id": "edge-s", "type": "foundation.edge", "positionM": [0, 1.6, 2], "normal": [0, 0, 1]},
        {"id": "edge-e", "type": "foundation.edge", "positionM": [2, 1.6, 0], "normal": [1, 0, 0]},
        {"id": "edge-w", "type": "foundation.edge", "positionM": [-2, 1.6, 0], "normal": [-1, 0, 0]},
        {"id": "top", "type": "foundation.top", "positionM": [0, 1.8, 0], "normal": [0, 1, 0]}
      ],
      "placement": {"requiresPlot": true, "terrainMode": "preserve", "maxSlopeDeg": 25, "allowsWater": true},
      "collider": {"type": "compound-box", "sizeM": [4, 1.8, 4]},
      "cost": {"credits": 120, "materials": {"wood": 30, "stone": 18, "metal": 6}},
      "structural": {"massKg": 900, "loadKg": 900, "capacityKg": 12000, "supportMode": "ground-anchor"},
      "tags": ["canal", "dock", "water-edge"]
    },
    {
      "id": "floor-oak-4x4",
      "version": 1,
      "category": "floor",
      "displayName": "Дубовый пол 4×4",
      "dimensionsM": [4, 0.2, 4],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/floor/oak-4x4",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "bottom", "type": "floor.bottom", "positionM": [0, 0, 0], "normal": [0, -1, 0]},
        {"id": "top", "type": "floor.top", "positionM": [0, 0.2, 0], "normal": [0, 1, 0]},
        {"id": "wall-n", "type": "floor.wall", "positionM": [0, 0.2, -2], "normal": [0, 0, -1]},
        {"id": "wall-s", "type": "floor.wall", "positionM": [0, 0.2, 2], "normal": [0, 0, 1]},
        {"id": "wall-e", "type": "floor.wall", "positionM": [2, 0.2, 0], "normal": [1, 0, 0]},
        {"id": "wall-w", "type": "floor.wall", "positionM": [-2, 0.2, 0], "normal": [-1, 0, 0]},
        {"id": "edge", "type": "floor.edge", "positionM": [0, 0.2, 2], "normal": [0, 0, 1]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "box", "sizeM": [4, 0.2, 4]},
      "cost": {"credits": 42, "materials": {"wood": 20, "metal": 1}},
      "structural": {"massKg": 190, "loadKg": 190, "capacityKg": 2200, "supportMode": "span"},
      "tags": ["interior", "warm", "residential"]
    },
    {
      "id": "floor-stone-4x4",
      "version": 1,
      "category": "floor",
      "displayName": "Каменный пол 4×4",
      "dimensionsM": [4, 0.24, 4],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/floor/stone-4x4",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "bottom", "type": "floor.bottom", "positionM": [0, 0, 0], "normal": [0, -1, 0]},
        {"id": "top", "type": "floor.top", "positionM": [0, 0.24, 0], "normal": [0, 1, 0]},
        {"id": "wall-n", "type": "floor.wall", "positionM": [0, 0.24, -2], "normal": [0, 0, -1]},
        {"id": "wall-s", "type": "floor.wall", "positionM": [0, 0.24, 2], "normal": [0, 0, 1]},
        {"id": "wall-e", "type": "floor.wall", "positionM": [2, 0.24, 0], "normal": [1, 0, 0]},
        {"id": "wall-w", "type": "floor.wall", "positionM": [-2, 0.24, 0], "normal": [-1, 0, 0]},
        {"id": "edge", "type": "floor.edge", "positionM": [0, 0.24, 2], "normal": [0, 0, 1]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "box", "sizeM": [4, 0.24, 4]},
      "cost": {"credits": 58, "materials": {"stone": 26, "metal": 2}},
      "structural": {"massKg": 760, "loadKg": 760, "capacityKg": 4000, "supportMode": "span"},
      "tags": ["ground-floor", "shop", "fire-resistant"]
    },
    {
      "id": "wall-brick-solid-4x3",
      "version": 1,
      "category": "wall",
      "displayName": "Кирпичная стена 4×3",
      "dimensionsM": [4, 3, 0.24],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/wall/brick-solid-4x3",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "wall.base", "positionM": [0, 0, 0], "normal": [0, -1, 0]},
        {"id": "side-l", "type": "wall.side", "positionM": [-2, 1.5, 0], "normal": [-1, 0, 0]},
        {"id": "side-r", "type": "wall.side", "positionM": [2, 1.5, 0], "normal": [1, 0, 0]},
        {"id": "top", "type": "wall.top", "positionM": [0, 3, 0], "normal": [0, 1, 0]},
        {"id": "surface", "type": "wall.surface", "positionM": [0, 1.7, -0.13], "normal": [0, 0, -1]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "box", "sizeM": [4, 3, 0.24]},
      "cost": {"credits": 66, "materials": {"stone": 30, "metal": 1}},
      "structural": {"massKg": 680, "loadKg": 680, "capacityKg": 5200, "supportMode": "load-bearing"},
      "tags": ["exterior", "canal-house", "fire-resistant"]
    },
    {
      "id": "wall-plaster-solid-4x3",
      "version": 1,
      "category": "wall",
      "displayName": "Оштукатуренная стена 4×3",
      "dimensionsM": [4, 3, 0.16],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/wall/plaster-solid-4x3",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "wall.base", "positionM": [0, 0, 0], "normal": [0, -1, 0]},
        {"id": "side-l", "type": "wall.side", "positionM": [-2, 1.5, 0], "normal": [-1, 0, 0]},
        {"id": "side-r", "type": "wall.side", "positionM": [2, 1.5, 0], "normal": [1, 0, 0]},
        {"id": "top", "type": "wall.top", "positionM": [0, 3, 0], "normal": [0, 1, 0]},
        {"id": "surface", "type": "wall.surface", "positionM": [0, 1.7, -0.09], "normal": [0, 0, -1]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "box", "sizeM": [4, 3, 0.16]},
      "cost": {"credits": 38, "materials": {"wood": 10, "stone": 8}},
      "structural": {"massKg": 190, "loadKg": 190, "capacityKg": 1200, "supportMode": "partition"},
      "tags": ["interior", "paintable", "low-cost"]
    },
    {
      "id": "window-sash-brick-4x3",
      "version": 1,
      "category": "window",
      "displayName": "Кирпичная стена с голландскими окнами",
      "dimensionsM": [4, 3, 0.24],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/window/sash-brick-4x3",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "window.base", "positionM": [0, 0, 0], "normal": [0, -1, 0]},
        {"id": "side-l", "type": "window.side", "positionM": [-2, 1.5, 0], "normal": [-1, 0, 0]},
        {"id": "side-r", "type": "window.side", "positionM": [2, 1.5, 0], "normal": [1, 0, 0]},
        {"id": "top", "type": "wall.top", "positionM": [0, 3, 0], "normal": [0, 1, 0]},
        {"id": "surface", "type": "wall.surface", "positionM": [0, 2.5, -0.13], "normal": [0, 0, -1]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "compound-box", "sizeM": [4, 3, 0.24]},
      "cost": {"credits": 94, "materials": {"stone": 18, "wood": 8, "glass": 10, "metal": 2}},
      "structural": {"massKg": 430, "loadKg": 430, "capacityKg": 2800, "supportMode": "load-bearing"},
      "tags": ["exterior", "daylight", "canal-house"]
    },
    {
      "id": "window-shopfront-red-4x3",
      "version": 1,
      "category": "window",
      "displayName": "Витрина с настраиваемым светом",
      "dimensionsM": [4, 3, 0.28],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/window/shopfront-4x3",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "window.base", "positionM": [0, 0, 0], "normal": [0, -1, 0]},
        {"id": "side-l", "type": "window.side", "positionM": [-2, 1.5, 0], "normal": [-1, 0, 0]},
        {"id": "side-r", "type": "window.side", "positionM": [2, 1.5, 0], "normal": [1, 0, 0]},
        {"id": "top", "type": "wall.top", "positionM": [0, 3, 0], "normal": [0, 1, 0]},
        {"id": "surface", "type": "wall.surface", "positionM": [0, 2.65, -0.15], "normal": [0, 0, -1]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "compound-box", "sizeM": [4, 3, 0.28]},
      "cost": {"credits": 132, "materials": {"stone": 12, "metal": 12, "glass": 20, "electronics": 3}},
      "structural": {"massKg": 360, "loadKg": 360, "capacityKg": 1800, "supportMode": "frame"},
      "runtime": {"emissiveColorDefault": "#ff315d", "emissiveIntensityMax": 3, "dynamicLightDefault": false},
      "tags": ["shop", "night", "custom-color", "storefront"]
    },
    {
      "id": "door-canal-brick-4x3",
      "version": 1,
      "category": "door",
      "displayName": "Фасад с входной дверью",
      "dimensionsM": [4, 3, 0.24],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/door/canal-brick-4x3",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "door.base", "positionM": [0, 0, 0], "normal": [0, -1, 0]},
        {"id": "side-l", "type": "door.side", "positionM": [-2, 1.5, 0], "normal": [-1, 0, 0]},
        {"id": "side-r", "type": "door.side", "positionM": [2, 1.5, 0], "normal": [1, 0, 0]},
        {"id": "top", "type": "wall.top", "positionM": [0, 3, 0], "normal": [0, 1, 0]},
        {"id": "surface", "type": "wall.surface", "positionM": [1.15, 2.35, -0.13], "normal": [0, 0, -1]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "compound-box", "sizeM": [4, 3, 0.24]},
      "cost": {"credits": 104, "materials": {"stone": 18, "wood": 12, "glass": 3, "metal": 4}},
      "structural": {"massKg": 410, "loadKg": 410, "capacityKg": 2600, "supportMode": "load-bearing"},
      "runtime": {"interaction": "hinged-door", "lockedByDefault": true},
      "tags": ["entry", "lockable", "exterior"]
    },
    {
      "id": "door-interior-plaster-4x3",
      "version": 1,
      "category": "door",
      "displayName": "Перегородка с дверью",
      "dimensionsM": [4, 3, 0.16],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/door/interior-plaster-4x3",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "door.base", "positionM": [0, 0, 0], "normal": [0, -1, 0]},
        {"id": "side-l", "type": "door.side", "positionM": [-2, 1.5, 0], "normal": [-1, 0, 0]},
        {"id": "side-r", "type": "door.side", "positionM": [2, 1.5, 0], "normal": [1, 0, 0]},
        {"id": "top", "type": "wall.top", "positionM": [0, 3, 0], "normal": [0, 1, 0]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "compound-box", "sizeM": [4, 3, 0.16]},
      "cost": {"credits": 54, "materials": {"wood": 16, "stone": 6, "metal": 2}},
      "structural": {"massKg": 150, "loadKg": 150, "capacityKg": 900, "supportMode": "partition"},
      "runtime": {"interaction": "hinged-door", "lockedByDefault": false},
      "tags": ["interior", "room-divider"]
    },
    {
      "id": "stairs-oak-straight-4x3",
      "version": 1,
      "category": "stairs",
      "displayName": "Прямая дубовая лестница",
      "dimensionsM": [1.2, 3, 4],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/stairs/oak-straight-4x3",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "stairs.base", "positionM": [0, 0, 1.7], "normal": [0, -1, 0]},
        {"id": "landing", "type": "stairs.landing", "positionM": [0, 3, -1.7], "normal": [0, 1, 0]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true, "clearanceM": [1.4, 3.2, 4.2]},
      "collider": {"type": "ramp", "sizeM": [1.2, 3, 4]},
      "cost": {"credits": 118, "materials": {"wood": 42, "metal": 6}},
      "structural": {"massKg": 310, "loadKg": 310, "capacityKg": 1600, "supportMode": "span"},
      "tags": ["interior", "two-storey", "walkable"]
    },
    {
      "id": "stairs-compact-turn-2x3",
      "version": 1,
      "category": "stairs",
      "displayName": "Компактная поворотная лестница",
      "dimensionsM": [2, 3, 2],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/stairs/compact-turn-2x3",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "stairs.base", "positionM": [0.6, 0, 0.6], "normal": [0, -1, 0]},
        {"id": "landing", "type": "stairs.landing", "positionM": [-0.6, 3, -0.6], "normal": [0, 1, 0]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true, "clearanceM": [2.2, 3.2, 2.2]},
      "collider": {"type": "compound-ramp", "sizeM": [2, 3, 2]},
      "cost": {"credits": 142, "materials": {"wood": 36, "metal": 12}},
      "structural": {"massKg": 280, "loadKg": 280, "capacityKg": 1400, "supportMode": "span"},
      "tags": ["interior", "compact", "walkable"]
    },
    {
      "id": "roof-gable-tile-4x4",
      "version": 1,
      "category": "roof",
      "displayName": "Черепичная двускатная крыша 4×4",
      "dimensionsM": [4.2, 1.7, 4.2],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/roof/gable-tile-4x4",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "bottom", "type": "roof.bottom", "positionM": [0, 0, 0], "normal": [0, -1, 0]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "compound-wedge", "sizeM": [4.2, 1.7, 4.2]},
      "cost": {"credits": 116, "materials": {"wood": 26, "stone": 18, "metal": 2}},
      "structural": {"massKg": 460, "loadKg": 460, "capacityKg": 700, "supportMode": "roof"},
      "tags": ["canal-house", "rainproof", "attic"]
    },
    {
      "id": "roof-flat-green-4x4",
      "version": 1,
      "category": "roof",
      "displayName": "Плоская зелёная крыша 4×4",
      "dimensionsM": [4, 0.32, 4],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/roof/flat-green-4x4",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "bottom", "type": "roof.bottom", "positionM": [0, 0, 0], "normal": [0, -1, 0]},
        {"id": "top", "type": "floor.top", "positionM": [0, 0.32, 0], "normal": [0, 1, 0]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "box", "sizeM": [4, 0.32, 4]},
      "cost": {"credits": 148, "materials": {"wood": 12, "stone": 22, "metal": 8}},
      "structural": {"massKg": 720, "loadKg": 720, "capacityKg": 1400, "supportMode": "roof"},
      "tags": ["modern", "walkable", "rain-buffer"]
    },
    {
      "id": "roof-dormer-tile-4x4",
      "version": 1,
      "category": "roof",
      "displayName": "Черепичная крыша с мансардным окном",
      "dimensionsM": [4.2, 2, 4.2],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/roof/dormer-tile-4x4",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "bottom", "type": "roof.bottom", "positionM": [0, 0, 0], "normal": [0, -1, 0]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "compound-wedge", "sizeM": [4.2, 2, 4.2]},
      "cost": {"credits": 176, "materials": {"wood": 34, "stone": 18, "glass": 4, "metal": 3}},
      "structural": {"massKg": 510, "loadKg": 510, "capacityKg": 650, "supportMode": "roof"},
      "tags": ["canal-house", "attic", "daylight"]
    },
    {
      "id": "furniture-sofa-2seat",
      "version": 1,
      "category": "furniture",
      "displayName": "Двухместный диван",
      "dimensionsM": [1.9, 0.88, 0.86],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/furniture/sofa-2seat",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "furniture.base", "positionM": [0, 0, 0], "normal": [0, -1, 0]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true, "wallClearanceM": 0.08},
      "collider": {"type": "box", "sizeM": [1.9, 0.88, 0.86]},
      "cost": {"credits": 74, "materials": {"wood": 8, "fabric": 14, "metal": 2}},
      "structural": {"massKg": 58, "loadKg": 58, "capacityKg": 260, "supportMode": "decor"},
      "runtime": {"interaction": "sit", "seats": 2},
      "tags": ["living-room", "seating"]
    },
    {
      "id": "furniture-table-dining",
      "version": 1,
      "category": "furniture",
      "displayName": "Обеденный стол",
      "dimensionsM": [1.6, 0.76, 0.9],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/furniture/table-dining",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "furniture.base", "positionM": [0, 0, 0], "normal": [0, -1, 0]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true, "useClearanceM": 0.75},
      "collider": {"type": "box", "sizeM": [1.6, 0.76, 0.9]},
      "cost": {"credits": 52, "materials": {"wood": 18, "metal": 2}},
      "structural": {"massKg": 42, "loadKg": 42, "capacityKg": 180, "supportMode": "decor"},
      "tags": ["dining", "surface"]
    },
    {
      "id": "furniture-bed-double",
      "version": 1,
      "category": "furniture",
      "displayName": "Двуспальная кровать",
      "dimensionsM": [1.8, 0.62, 2.1],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/furniture/bed-double",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "furniture.base", "positionM": [0, 0, 0], "normal": [0, -1, 0]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true, "useClearanceM": 0.65},
      "collider": {"type": "box", "sizeM": [1.8, 0.62, 2.1]},
      "cost": {"credits": 86, "materials": {"wood": 16, "fabric": 18, "metal": 3}},
      "structural": {"massKg": 76, "loadKg": 76, "capacityKg": 320, "supportMode": "decor"},
      "runtime": {"interaction": "sleep", "slots": 2},
      "tags": ["bedroom", "sleep"]
    },
    {
      "id": "furniture-cabinet-tall",
      "version": 1,
      "category": "furniture",
      "displayName": "Высокий шкаф",
      "dimensionsM": [1, 2.1, 0.55],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/furniture/cabinet-tall",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "furniture.base", "positionM": [0, 0, 0], "normal": [0, -1, 0]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true, "wallClearanceM": 0.05},
      "collider": {"type": "box", "sizeM": [1, 2.1, 0.55]},
      "cost": {"credits": 64, "materials": {"wood": 20, "metal": 3}},
      "structural": {"massKg": 68, "loadKg": 68, "capacityKg": 220, "supportMode": "decor"},
      "runtime": {"interaction": "storage", "slots": 24},
      "tags": ["storage", "interior"]
    },
    {
      "id": "light-wall-canal",
      "version": 1,
      "category": "lighting",
      "displayName": "Настенный фонарь",
      "dimensionsM": [0.32, 0.58, 0.42],
      "pivot": "back-center",
      "assetRef": "procedural://testcs/lighting/wall-canal",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "wall", "type": "light.wall", "positionM": [0, 0, 0.21], "normal": [0, 0, 1]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "box", "sizeM": [0.32, 0.58, 0.42]},
      "cost": {"credits": 36, "materials": {"metal": 5, "glass": 2, "electronics": 1}},
      "structural": {"massKg": 8, "loadKg": 8, "capacityKg": 0, "supportMode": "decor"},
      "runtime": {"interaction": "toggle-light", "emissiveColorDefault": "#ffcf8a", "dynamicLightDefault": false, "dynamicLightMaxRangeM": 6},
      "tags": ["night", "exterior", "low-cost-lighting"]
    },
    {
      "id": "furniture-planter-window",
      "version": 1,
      "category": "furniture",
      "displayName": "Оконная цветочница",
      "dimensionsM": [1.2, 0.35, 0.35],
      "pivot": "bottom-center",
      "assetRef": "procedural://testcs/furniture/planter-window",
      "source": {"author": "TESTCS", "license": "TESTCS-original"},
      "snapPoints": [
        {"id": "base", "type": "furniture.base", "positionM": [0, 0, 0], "normal": [0, -1, 0]}
      ],
      "placement": {"requiresPlot": true, "requiresSupport": true},
      "collider": {"type": "box", "sizeM": [1.2, 0.35, 0.35]},
      "cost": {"credits": 28, "materials": {"wood": 4, "stone": 3}},
      "structural": {"massKg": 28, "loadKg": 28, "capacityKg": 0, "supportMode": "decor"},
      "tags": ["exterior", "greenery", "canal-house"]
    }
  ]
}
